// Styles for RoundUp go here.
import styled from 'styled-components';
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';

export const StyledRoundUp = styled.div`
  .roundup {
    padding: ${toRem(48)} 0;
    @media ${baseVariables.mediaQuery.lg} {
      padding: ${toRem(64)} 0;
    }

    &-first-item {
      padding-bottom: ${toRem(64)};
    }
    &-spacing {
      padding-bottom: ${toRem(64)};
    }

    &-number {
      color: ${contextualVariable.accentColor};
      .separator {
        border-bottom: ${toRem(1)} solid ${baseVariables.color['base10']};
        color: inherit;
      }
    }

    &-cta {
      &-link {
        padding-bottom: ${toRem(1)};
        display: inline;
        [dir='rtl'] & {
          border-bottom: unset;
          text-decoration: underline;
        }
      }
    }

    &-image {
      width: 100%;
      aspect-ratio: 1/1;
    }

    .cards-column-section__highlight {
      display: flex;
      justify-content: center;
      align-items: start;

      .card-details-wrapper {
        @media ${baseVariables.mediaQuery.lg} {
          padding: 0 ${toRem(48)};
        }
      }
    }

    &-other-slide {
      margin-bottom: ${toRem(24)};

      @media ${baseVariables.mediaQuery.md} {
        margin-bottom: ${toRem(48)};
      }

      @media ${baseVariables.mediaQuery.lg} {
        margin-bottom: ${toRem(64)};
      }

      &:last-child,
      &:nth-last-of-type(-n + 2):not(:nth-child(even)):not(:nth-child(odd)) {
        margin-bottom: ${toRem(0)} !important;
      }
    }

    &-number {
      color: ${contextualVariable.accentColor} !important;

      .separator {
        border-bottom: ${toRem(1)} solid ${baseVariables.color['base10']};
        color: inherit;
      }

      &.number-up {
        background-color: ${baseVariables.color['base20']};
        position: absolute;
        margin-left: ${toRem(48)} !important;

        margin-top: ${toRem(-52)} !important;

        @media ${baseVariables.mediaQuery.md} {
          margin-top: ${toRem(-64)} !important;
        }
        @media ${baseVariables.mediaQuery.lg} {
          margin-top: ${toRem(-75)} !important;
        }

        [dir='rtl'] & {
          margin-right: ${toRem(48)} !important;
        }
      }
    }

    &-highlight-number {
      color: ${contextualVariable.accentColor} !important;

      .separator {
        border-bottom: ${toRem(1)} solid ${baseVariables.color['base10']};
        color: inherit;
      }
    }

    .highlight-card-section {
      @media ${baseVariables.mediaQuery.md} {
        margin: 0 ${toRem(-24)};
      }
    }

    .highlight-card-details-wrapper {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    .highlight-card {
      margin-top: ${toRem(24)};

      margin-bottom: ${toRem(16)};
      @media ${baseVariables.mediaQuery.lg} {
        margin-bottom: ${toRem(48)};
      }

      &-details-wrapper {
        padding: ${toRem(32)} 0;
      }
    }

    &-highlight-img {
      img {
        width: 100%;
        aspect-ratio: 1/1;

        @media ${baseVariables.mediaQuery.md} {
          aspect-ratio: 5/2;
        }
      }
    }

    &-highlight-cinemograph {
      .video-js {
        width: 100%;
        aspect-ratio: 1/1;

        @media ${baseVariables.mediaQuery.md} {
          aspect-ratio: 5/2;
        }

        height: auto !important;
        padding-top: 0 !important;

        .vjs-tech {
          object-fit: cover;
        }
      }

      .vjs-control-bar,
      .vjs-title-bar {
        display: none;
      }

      .icon-play-pause {
        position: absolute;
        top: ${toRem(24)};
        right: ${toRem(24)};
        [dir='rtl'] & {
          right: unset !important;
          left: ${toRem(24)} !important;
        }
        width: ${toRem(80)};
        height: ${toRem(80)};
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          opacity: 0.62;
          height: ${toRem(48)};
          width: ${toRem(48)};
          background: ${baseVariables.color['base10']};
          color: ${baseVariables.color['base20']};
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;

          &:hover {
            opacity: 1;
            transition: 0.5s;
          }
        }
      }
    }

    p {
      margin-bottom: 0;
    }
  }

  .roundup-title {
    [dir='rtl'] & {
      display: inline-block;
      padding-top: ${toRem(4)};
    }
  }
`;
